<template>
<link v-if="isUmbraco" rel="stylesheet" href="/assets/index.css" />

  <button :class="classes" @click="handleClick">
      {{ label }}
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
    <g id="Group 2786">
      <path
        id="Vector 4"
        d="M1.5 1.5L12.5 12.5"
        stroke="#612141"
        stroke-width="3"
      />
      <path
        id="Vector 5"
        d="M12.5 1.5L1.5 12.5"
        stroke="#612141"
        stroke-width="3"
      />
    </g>
</svg>
  </button>
</template>

<script lang="ts" setup>
import { computed } from "vue";

export interface ButtonProps {
  label: string;
  classes?: string;
}

const props = withDefaults(defineProps<ButtonProps>(), {
  label: "Clear all",
});

type Emits = {
  (e: "handleClick"): void;
};
const emit = defineEmits<Emits>();

const handleClick = () => {
  emit("handleClick");
};


const classes = computed(() => {
  return `font-bold text-xs sm:text-sm text-aubergine-40 hover:text-typography transition-all font-bold ease-in-out duration-200 flex relative items-center justify-end z-0 bg-primary gap-3 ${props.classes}`;
});
</script>
